import React, { useEffect, useState, useContext } from "react";
import "../css/alert_banner.css";

export default function AlertBanner({
  text,
  type,
  fadeOutDuration = 2000,
  cb_del,
  id,
}) {
  const [isHidden, setIsHidden] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsHidden(true);
    }, fadeOutDuration); // Start the fade-out animation after 2 seconds

    const timer2 = setTimeout(() => {
      cb_del(id);
    }, fadeOutDuration + 1000); // Delete the alert banner after 4 seconds
    return () => {
      clearTimeout(timer);
      clearTimeout(timer2);
    };
  }, []);

  return (
    <div
      className={`alert-banner fade-out ${isHidden ? "hide" : ""}
            ${type}
            `}
    >
      {text}
    </div>
  );
}


/* TYPES OF ALERTS

.danger{
    background-color: #F44336;
}

.success{
    background-color: #04AA6D;
}

.info{
    background-color: #2196F3;
}

.warning{
    background-color: #ffcc00;
}


*/